import React from 'react';
import {
    Box,
    ToggleButtonGroup,
    ToggleButton,
} from '@mui/material';
import theme from "../../theme/theme";

interface ToggleTabsProps {
    value: number;
    onChange: (event: React.MouseEvent<HTMLElement>, newValue: number) => void;
    tabLabels: string[];
}

const ToggleTabs: React.FC<ToggleTabsProps> = ({ value, onChange, tabLabels }) => {
    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                maxWidth: '100%',
                overflow: 'hidden',
                px: 1,
                pb: 2,
            }}
        >
            <ToggleButtonGroup
                value={value}
                exclusive
                onChange={(event, newValue) => {
                    if (newValue !== null) {
                        onChange(event, newValue);
                    }
                }}
                size="small"
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    flexGrow: 1,
                    p:1,
                    '& .MuiToggleButtonGroup-grouped:first-of-type': {
                        borderTopLeftRadius: 4,
                        borderBottomLeftRadius: 4,
                    },
                    '& .MuiToggleButtonGroup-grouped:last-of-type': {
                        borderTopRightRadius: 4,
                        borderBottomRightRadius: 4,
                    },
                }}
            >
                {tabLabels.map((label, index) => (
                    <ToggleButton
                        key={label}
                        value={index}
                        disableRipple
                        sx={{
                            borderRadius: 0,
                            textTransform: 'none',
                            px: 2,
                            fontSize: '16px',
                            '&.Mui-focusVisible': {
                                outline: `2px solid ${theme.palette.custom.customBlue}`,
                            },
                            '&.Mui-selected': {
                                backgroundColor: theme.palette.custom.customBackgroundGray,
                                borderColor: theme.palette.custom.customLightGray,
                                borderWidth: 1,
                            },
                            '&.Mui-selected:hover': {
                                backgroundColor: theme.palette.custom.customBackgroundGray,
                                borderColor: theme.palette.custom.customLightGray,
                                borderWidth: 1,
                            },
                        }}
                    >
                        {label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Box>
    );
};

export default ToggleTabs;
